import * as m from "@/paraglide/messages"

export type PlanId = "monster_7d" | "monster_1m" | "monster_3m"

export type PlanBadge = "hit" | "best-price"

/** Trial length in days — drives CTA copy ("7 дней — 0₽") and backend `trial_ends_at`. */
export const TRIAL_DAYS = 7

export type PlanDef = {
	id: PlanId
	amountRub: number
	cloudPaymentsId: string
	appStoreId: string
	googlePlayId: string
	rustoreId: string
	recurrentInterval: "Day" | "Month"
	recurrentPeriod: number
	badge: PlanBadge | null
}

export const PLAN_CATALOG: Record<PlanId, PlanDef> = {
	monster_7d: {
		id: "monster_7d",
		amountRub: 99,
		cloudPaymentsId: "premium_7_days",
		appStoreId: "premium_7_days",
		googlePlayId: "premium_7_days",
		rustoreId: "premium_7_days",
		recurrentInterval: "Day",
		recurrentPeriod: 7,
		badge: null,
	},
	monster_1m: {
		id: "monster_1m",
		amountRub: 349,
		cloudPaymentsId: "monster_monthly",
		appStoreId: "premium_monthly",
		googlePlayId: "premium_monthly",
		rustoreId: "premium_monthly",
		recurrentInterval: "Month",
		recurrentPeriod: 1,
		badge: "hit",
	},
	monster_3m: {
		id: "monster_3m",
		amountRub: 479,
		cloudPaymentsId: "premium_3_months",
		appStoreId: "premium_3_months",
		googlePlayId: "premium_3_months",
		rustoreId: "premium_3_months",
		recurrentInterval: "Month",
		recurrentPeriod: 3,
		badge: "best-price",
	},
}

export const PLAN_ORDER: readonly PlanId[] = [
	"monster_7d",
	"monster_1m",
	"monster_3m",
]

export function parsePlanId(value: string | null | undefined): PlanId | null {
	if (
		value === "monster_7d" ||
		value === "monster_1m" ||
		value === "monster_3m"
	) {
		return value
	}
	return null
}

export function getPlanShortLabel(planId: PlanId): string {
	switch (planId) {
		case "monster_7d":
			return m.monsterPlanLabel7d()
		case "monster_1m":
			return m.monsterPlanLabel1m()
		case "monster_3m":
			return m.monsterPlanLabel3m()
	}
}

export function getPlanFullLabel(planId: PlanId): string {
	switch (planId) {
		case "monster_7d":
			return m.monsterPlanFullName7d()
		case "monster_1m":
			return m.monsterPlanFullName1m()
		case "monster_3m":
			return m.monsterPlanFullName3m()
	}
}

/** Renewal period word for the trial CTA subline ("99₽/{неделя}"). */
export function getPlanPeriodLabel(planId: PlanId): string {
	switch (planId) {
		case "monster_7d":
			return m.monsterTrialPeriod7d()
		case "monster_1m":
			return m.monsterTrialPeriod1m()
		case "monster_3m":
			return m.monsterTrialPeriod3m()
	}
}
